import type { OtherCostCalculationTypeEnum, ProjectMethodologyEnum } from 'gql/graphql';

export enum CatalogOtherAndLimitedTab {
    Others = 'others',
    Limited = 'limited',
}

export type TCatalogOtherAndLimitedTabItem = {
    id: CatalogOtherAndLimitedTab;
    label: string;
};

export type TCatalogSectionItem = {
    id: string;
    label: string;
};

export type TCatalogOtherAndLimitedItem = {
    id: number;
    name: string;
    calculatingType: OtherCostCalculationTypeEnum;
    typeName: string;
    typeUniqueId?: string;
    formula: string;
    methodology: ProjectMethodologyEnum;
    groupName: string;
    sectionId: string;
    isAdditionalTransport?: boolean;
    isGroup?: false;
};

export type TCatalogOtherAndLimitedGroupRow = {
    id: string;
    name: string;
    isGroup: true;
};

export type TCatalogOtherAndLimitedRow = TCatalogOtherAndLimitedItem | TCatalogOtherAndLimitedGroupRow;

export type TCatalogOtherAndLimitedId = number | null;

export type TCatalogCostTypeOption = {
    id: string;
    name: string;
    isSystem?: boolean;
};

export type TCatalogCostFormValues = {
    name: string;
    methodology: { id: ProjectMethodologyEnum; label: string };
    costType: TCatalogCostTypeOption | null;
    formula: unknown;
};
